module.exports = __webpack_public_path__ + "static/Mee@2x.1abf5826.png";